import type { Handler, NextFn, RequestContext } from "@ember-data/request";
import RequestManager from "@ember-data/request";
import Fetch from "@ember-data/request/fetch";
import type Owner from "@ember/owner";
import { getOwner } from "@ember/owner";

export function WiseHandler(applicationInstance?: Owner): Handler {
  return {
    request<T>(context: RequestContext, next: NextFn<T>) {
      // Get the owner from the store if it is present, or use the provided
      // applicationInstance otherwise
      const owner = context.request.store
        ? getOwner(context.request.store)
        : applicationInstance;

      // Our header's authentication logic is factorized in the application
      // adapter so far, so let's fetch it
      const applicationAdapter = owner?.lookup("adapter:application") as {
        headers: HeadersInit;
      };

      const headers = new Headers(applicationAdapter.headers);
      headers.append("Content-Type", "application/json");

      return next(Object.assign({}, context.request, { headers }));
    }
  };
}

export default class extends RequestManager {
  constructor(args?: Record<string | symbol, unknown>) {
    super(args);

    // @ts-expect-error RequestManager.prototype.use is not typed
    this.use([WiseHandler(getOwner(this)), Fetch]);
  }
}
